var _g, _path, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "-3.159 -5.068 30 30",
    enableBackground: "new -3.159 -5.068 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M11.843,15.954c0.824,0,4.313-8.567,4.733-11.692c0.396-2.938-2.119-5.368-4.733-5.368 S6.695,1.327,7.109,4.262C7.551,7.384,11.053,15.954,11.843,15.954z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#272727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 11.841,
    cy: 16.251,
    rx: 6.699,
    ry: 2.656
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#272727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 11.841,
    cy: 16.9,
    rx: 10.125,
    ry: 4.462
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.9d31bf430d5f49b444d17ce67d187674.svg";
export { ForwardRef as ReactComponent };